import { Component, OnInit,ViewChild } from '@angular/core';
import { EmployeeService } from 'app/shared/services/employee.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit {

  displayedColumns: string[] = ['EmpNo', 'EmpName', 'Phone', 'Email','Status','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;
  dataList : any;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  

  constructor(private employeeService : EmployeeService,
              private dialogService : DialogService,
              private router : Router, 
              private route : ActivatedRoute, 
              private toastr: ToastrService,
              private themeService: NbThemeService,
              private authService: AuthService,

         ) { }

  ngOnInit() {
    this.getAllEmployees();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  }
  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='EM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  newButtonClick(){
  this.employeeService.dataRow = null;
  this.router.navigate(['../employee'],{relativeTo : this.route});
  }

  getAllEmployees(){
    this.employeeService.getAll()
     .subscribe(
        (data) => {
                  this.dataList = data;
                  this.dataSource = new  MatTableDataSource (this.dataList );  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }
   

     getRowData(row){   
      this.employeeService.dataRow = row;  
      this.router.navigate(['../employee'],{relativeTo : this.route});
     
    }

     deleteButtonClick(id : number){

      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.employeeService.delete(id)
        .subscribe(
          (res) => {
                      this.toastr.success('Record deleted successfully','Success');
                      this.getAllEmployees();
                      console.log(res);     
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
   }

   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }






}
